import { render, staticRenderFns } from "./BATCertificate.vue?vue&type=template&id=9ab98396&scoped=true"
import script from "./BATCertificate.vue?vue&type=script&lang=js"
export * from "./BATCertificate.vue?vue&type=script&lang=js"
import style0 from "./BATCertificate.vue?vue&type=style&index=0&id=9ab98396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab98396",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
